<template>
  <div class="row mb-1">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
      <div class="widget-12 card card-default widget-loader-circle shade">
        <div class="card-body">
          <div class="row">
            <div id="jurnalis" class="col-md-4">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">Jurnalis</h4>
                    <p class="small hint-text">Daftar Jurnalis</p>
                  </div>
                  <div class="pull-right">
                    <div class="form-check form-check-inline switch m-t-20">
                      <input
                        type="checkbox"
                        v-model="show_grafik_pie"
                        id="pie-jurnalis"
                      />
                      <label for="pie-jurnalis">Tampilkan Grafik</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <loader-component v-if="is_loading" />
                  <div v-else>
                    <div
                      v-if="!data"
                      class="alert alert-danger"
                      role="alert"
                      align="center"
                    >
                      <strong> Mohon maaf, data tidak tersedia! </strong>
                      <br />
                      Tidak dapat menampilkan grafik dengan data kosong.
                    </div>
                    <div v-else>
                      <table-dynamic-component
                        v-if="!show_grafik_pie"
                        :data_head="data.table.dt_head"
                        :data_body="data_body"
                        :data_head_class="data_head_class"
                        :config="data.table.dt_config"
                        table_class="table-stripped"
                        table_id="media-cetak-table"
                      />
                      <div v-else>
                        <pie-chart-component
                          :data="data_pie"
                          :config="config_pie"
                          :height="350"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="media-cetak" class="col-md-8">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">Media Cetak</h4>
                    <p class="small hint-text">Data Media Cetak</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <loader-component v-if="is_loading" />
                  <div v-else>
                    <div
                      v-if="!data"
                      class="alert alert-danger"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong>
                      <br />
                      Tidak dapat menampilkan grafik dengan data kosong.
                    </div>
                    <dynamic-chart-component
                      v-else
                      :config="config"
                      chart_id="garfik-media-cetak"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "@/views/components/loader.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";

export default {
  name: "medkon_jurnalis_media_cetak",
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
  data() {
    return {
      chart_config: null,
      show_grafik_pie: false,
      config: null,
      data_pie: [],
      config_pie: {
        align: "center",
        height: 300,
        itemWidth: 150,
      },
      data_body: [],
      data_head_class: [
        {
          head: "Jumlah",
          class: "text-center",
        },
      ],
    };
  },
  components: {
    "loader-component": loader,
    "table-dynamic-component": table_dynamic,
    "pie-chart-component": pie_chart,
    "dynamic-chart-component": dynamic_chart,
  },
  methods: {
    assemblePieChart() {
      if (
        this.data &&
        this.data.table &&
        Object.keys(this.data.table).length > 0
      ) {
        for (let i = 0; i < this.data.table.dt_body.length; i++) {
          this.data_pie.push({
            name: this.data.table.dt_body[i][0],
            y: this.data.table.dt_body[i][1],
          });
        }
      }
    },
    assembleJurnalisTable() {
      if (this.data && this.data.table) {
        this.data.table.dt_body.forEach((el) => {
          this.data_body.push([el[0], `<center>${el[1]}</center>`]);
        });
      }
    },
    setData() {
      this.assembleJurnalisTable();
      this.assemblePieChart();
      let self = this;
      if (this.data) {
        self.config = {
          chart: {
            type: "column",
            backgroundColor: "transparent",
            marginTop: 30,
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          xAxis: {
            categories: self.data.grafik.categories,
          },
          yAxis: {
            min: 0,
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
                color: "gray",
              },
            },
          },
          legend: {
            align: "center",
          },
          tooltip: {
            headerFormat: "<b>{point.x}</b><br/>",
            pointFormat:
              "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
          },
          plotOptions: {
            column: {
              stacking: "normal",
              dataLabels: {
                enabled: true,
              },
              point: {
                events: {
                  click: function() {
                    let params = {};
                    params = {
                      q: '"' + self.category + '"',
                    };
                    self.$router.push({ path: "/posts", query: params });
                  },
                },
              },
            },
          },
          series: self.data.grafik.series,
        };
      }
    },
  },
  created: function() {
    this.setData();
  },
  watch: {
    data() {
      this.setData();
    },
  },
};
</script>
